module.exports = "<p>\r\n  statcommandemp works!\r\n</p>\r\n"